import { IRoute, Material } from '../../sp-types';
import { formatToShortString } from '../../utils/FormatValue';
import { getUnitObj } from '../../utils/MassUnits/massUnitsUtils';
import { Props } from './BalanceRouteMetricCard';

export const routeToBalanceRouteCardProps = (
  routeData: IRoute,
  onClickOnRoute: (_routeId: string) => void,
  formulaId: string,
  componentNumberId: string,
  material: Material,
  pickedRouteId?: boolean,
): Props => {
  const {
    id,
    description,
    executionDuration,
    isFlexibleForChanges,
    isShippingFeesProtected,
    minMaxQuantity,
    name,
    prices,
    risk,
    materials,
    correlation,
  } = routeData;

  return {
    id: componentNumberId,
    calenderCellValue: `${executionDuration.min}-${executionDuration.max}`,
    isPicked: pickedRouteId ? true : false,
    RouteName: name,
    collateralCellValue:
      Object.values(prices)
        .reduce((total, priceCollateral) => total + priceCollateral.collateral, 0)
        .toFixed(0) + '$',
    pricePerTon:
      '$' +
      formatToShortString(
        Object.values(prices).reduce((total, priceCollateral) => total + priceCollateral.price, 0),
        0,
      ) +
      ' USD',
    correlation: (materials?.[formulaId] || correlation) + '%',
    onClickOnRoute: () => onClickOnRoute(id),
    riskCellValue: Object.values(risk).reduce((total, riskValue) => total + riskValue, 0),
    quantityCellValue: `${formatToShortString(minMaxQuantity[0], 0)} ${
      minMaxQuantity.length > 1 ? '- ' + formatToShortString(minMaxQuantity[1], 0) : ''
    } ${getUnitObj(material?.unit).shortForm} `,
    routeDescription: description,
    isFlexibleCell: isFlexibleForChanges,
    isFullGuarantee: false,
    isPhysicalDeliveryCell: isShippingFeesProtected,
    isShipmentProtectedCell: isShippingFeesProtected,
    routeToolTipText: description,
    massUnit: getUnitObj(material?.unit).shortForm,
  };
};
